// extracted by mini-css-extract-plugin
export default {"input":"ProfileInfo_input__EMRTC","buttonContainer":"ProfileInfo_buttonContainer__SZEcv","button":"ProfileInfo_button__GT1-f"};